// src/TestimonialsSection.jsx (or your components directory)
import React from "react";

// Placeholder Avatar Component
const AvatarPlaceholder = ({ bgColor = "bg-gray-300", initials = "" }) => (
  <div
    className={`w-12 h-12 rounded-full ${bgColor} flex items-center justify-center text-white font-semibold text-lg mr-4 flex-shrink-0`}
  >
    {initials}
    {/* Or you could use an SVG icon here */}
  </div>
);

// Testimonial Card Component
const TestimonialCard = ({
  name,
  handle,
  avatarInitials,
  avatarBg,
  text,
  isFaded = false,
}) => (
  <div
    className={`bg-white p-6 rounded-xl shadow-lg flex flex-col h-full ${
      isFaded ? "opacity-60" : ""
    }`}
  >
    <div className="flex items-center mb-4">
      <AvatarPlaceholder bgColor={avatarBg} initials={avatarInitials} />
      <div>
        <h4 className="font-semibold text-gray-800">{name}</h4>
        <p className="text-sm text-gray-500">{handle}</p>
      </div>
    </div>
    <p
      className={`text-gray-700 text-sm leading-relaxed ${
        isFaded ? "text-gray-500" : ""
      }`}
    >
      "{text}"
    </p>
  </div>
);

const TestimonialsSection = () => {
  // --- UPDATED TESTIMONIALS DATA ---
  const testimonialsData = [
    {
      name: "Account Clerk/Admin Executive",
      handle: "Verified User",
      avatarInitials: "AC",
      avatarBg: "bg-blue-500",
      text: "The platform is user friendly. I found the Resume upload feature most useful. The skill-matching results was fantastic, It helped me identify new opportunities. Overall, I would rate the user experience 5/5 and I highly recommend this platform.",
    },
    {
      name: "Project Manager",
      handle: "Verified User",
      avatarInitials: "PM",
      avatarBg: "bg-pink-500",
      text: "I found the Job suggestions and Percentage compatibility feature most useful. Great App.",
    },
    {
      name: "Project Manager",
      handle: "Verified User",
      avatarInitials: "PM",
      avatarBg: "bg-green-500",
      text: "I love the resume analysis feature. Overall, I would rate the user experience 3/5 and I highly recommend this platform.",
    },
    {
      name: "Business Analyst",
      handle: "Verified User",
      avatarInitials: "BA",
      avatarBg: "bg-purple-500",
      text: "I found the direct link to a job application feature most useful. Great platform to help discover new job opportunity I match to.",
    },
    {
      name: "Data Analyst",
      handle: "Verified User",
      avatarInitials: "DA",
      avatarBg: "bg-yellow-500",
      text: "I found the resume optimization and skill matching feature most useful. The skill-matching results were rated 5/5. It helped me identify new opportunities. Overall, I would rate the user experience 3/5 and I highly recommend this platform.",
    },
  ];

  return (
    // Added font-poppins class here
    <section className="py-16 lg:py-24 bg-gray-50 font-poppins">
      {" "}
      {/* Light gray background for the section */}
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        {/* Section Header */}
        <div className="text-center mb-12 lg:mb-16">
          <p className="text-sm font-semibold text-[#E55812] uppercase tracking-wider mb-1">
            Testimonials
          </p>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            Real Stories, Real Results
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base md:text-lg">
            See what users say about SkillMatch AI—how our smart tools simplify
            job hunting and Resume building.
          </p>
        </div>

        {/* Testimonials Grid */}
        {/* Using CSS Grid for a masonry-like effect (items will flow and fill space) */}
        {/* Adjust column count for different breakpoints as needed */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {testimonialsData.map((testimonial, index) => (
            <TestimonialCard
              key={index}
              name={testimonial.name}
              handle={testimonial.handle}
              avatarInitials={testimonial.avatarInitials}
              avatarBg={testimonial.avatarBg}
              text={testimonial.text}
              isFaded={testimonial.isFaded}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
